import Collapse from './src/collapse.vue'
import CollapseItem from './src/collapse-item.vue'

Collapse.Item = CollapseItem;

export default Collapse
